import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetApprovalCodeParams extends PaginationProps {}

interface CreateApprovalCode {
  name: string;
  approvalTypeIds: number[];
}

interface UpdateApprovalCode extends CreateApprovalCode {
  id: number | null;
}

export async function getApprovalCodes() {
  const { data } = await api.get('/approval-codes');
  return data;
}

export async function getApprovalCodesMasterData(
  params: GetApprovalCodeParams
) {
  const { data } = await api.get('/approval-codes/master-data', {
    params
  });
  return data;
}

export async function getApprovalCode(id: number) {
  const { data } = await api.get(`/approval-codes/${id}`);
  return data;
}

export async function createApprovalCode(
  createApprovalCode: CreateApprovalCode
) {
  const { data } = await api.post('/approval-codes', createApprovalCode);
  return data;
}

export async function updateApprovalCode(
  updateApprovalCode: UpdateApprovalCode
) {
  const { data } = await api.put(
    `/approval-codes/${updateApprovalCode.id}`,
    updateApprovalCode
  );
  return data;
}

export function deleteApprovalCode(id: number) {
  return api.delete(`/approval-codes/${id}`);
}
